import apiClient from "../../utils/api.client";

export const getMPDetallePagos = async (
  inst,
  agencias,
  rango_dias,
  fecha_desde,
  fecha_hasta,
  plataforma
) => {
  try {
    const response = await apiClient.get(
      `/apiMercadoPago/api/${plataforma}/consultarDetallePagos/abaco?inst=${inst}&agencias=${agencias}&fecha_desde=${fecha_desde + "T00:00:00"}&fecha_hasta=${fecha_hasta + "T23:59:59"}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error fetching getMPDetallePagos", error);
    const respuesta = [];
    return respuesta;
  }
};

export const getMPTotalPagos = async (
  inst,
  agencias,
  rango_dias,
  fecha_desde,
  fecha_hasta,
  plataforma
) => {
  try {
    const response = await apiClient.get(
      `/apiMercadoPago/api/${plataforma}/consultarTotalPagos/abaco?inst=${inst}&agencias=${agencias}&fecha_desde=${fecha_desde + "T00:00:00"}&fecha_hasta=${fecha_hasta + "T23:59:59"}`,
    );
    const data = response.data;
    return data;
  } catch (error) {
    console.log("Error fetching getMPTotalPagos", error);
    const respuesta = [];
    return respuesta;
  }
};
